import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateListPayload } from '@app-store/slices/rfqs/createRfq'

interface TaskAction extends Action {
    payload: ICreateListPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.rfqs.createRfq

function* createRfqSagaTask({ payload }) {
    try {
        const response = yield axios.post(`/companies/rfqs`, payload.data)
        yield put(onSuccess(response.result._id))
        if (response.success) {
            if (payload.sagaCB) {
                payload.sagaCB?.onSuccess(response.result)
            }
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* createRfqSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createRfqSagaTask)
}

export default createRfqSaga
